import { Injectable } from '@angular/core';
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { get } from 'lodash-es';
import { EnvironmentConfigurationService } from '@nimbus-library/features/configuration';
import { debugLanguageEnvironments, Language } from '../models/enums/language.enum';

@Injectable()
export class MissingTranslationHandlerService implements MissingTranslationHandler {
  public constructor(public readonly environmentConfigurationService: EnvironmentConfigurationService) {}

  public handle(params: MissingTranslationHandlerParams) {
    if (
      debugLanguageEnvironments.includes(this.environmentConfigurationService.configurationSettings.environmentName) &&
      params.translateService.currentLang === Language.Debug
    ) {
      return params.key;
    }
    const translation = params.translateService.translations[params.translateService.defaultLang];
    if (!!translation && get(translation, params.key)) {
      return params.translateService.getParsedResult(
        params.translateService.translations[params.translateService.defaultLang],
        params.key,
        params.interpolateParams,
      );
    }

    return params.key;
  }
}
